/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { PersonaSize } from "@fluentui/react";
import { TeamStore } from "sh-stores";

import { IUserPersonaProps } from "../../common/IUserPersonaProps";

import { CrossLocationTeamNameProps } from "./CrossLocationTeamNameProps";
import { ShiftDetailsProps } from "./ShiftDetails";

const styles = require("./ShiftDetails.scss");

/**
 * Gets the added by UserPersona props if 'shift.lastModifiedBy' is set.
 * @param props The properties.
 * @returns The added by UserPersona props if 'shift.lastModifiedBy' is set.
 */
export const getAddedByUserPersonaProps = (props: ShiftDetailsProps): IUserPersonaProps | undefined => {
    const { shift } = props;
    const addedByUserId = shift.lastModifiedBy?.userId;
    let personaProps: IUserPersonaProps | undefined = undefined;

    if (shift.isCrossLocationShift && addedByUserId) {
        personaProps = {
            className: styles.addedBy,
            showUserNameFromUserId: true,
            size: PersonaSize.size32,
            crossLocationTeamId: shift.senderTeamId,
            userId: addedByUserId
        };
    }

    return personaProps;
};

/**
 * Retrieves the 'CrossLocationTeamName' component props if the shift is from an external team, else returns undefined.
 * @param props The properties.
 * @returns The 'CrossLocationTeamName' component props if the shift is from an external team, else undefined.
 */
export const getCrossLocationTeamNameProps = (props: ShiftDetailsProps): CrossLocationTeamNameProps | undefined => {
    const { shift } = props;
    const { teamId } = TeamStore();
    const isCrossLocationShiftFromExternalTeam = shift.isCrossLocationShift && shift.teamId && shift.teamId != teamId;
    let teamNameProps: CrossLocationTeamNameProps | undefined = undefined;

    if (isCrossLocationShiftFromExternalTeam) {
        teamNameProps = {
            crossLocationTeamId: shift.teamId
        };
    }

    return teamNameProps;
};
